import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addressList: null,
  isLoading: false,
  isSuccess: true,
  isDeleteLoading: false,
  editAddressDetails: null,
  isSaveLoading: false,
  isEditAddressSuccess: false,
};

const accountAddressBookSlice = createSlice({
  name: "accountAddressBook",
  initialState,
  reducers: {
    requestToFetchAccountAddressList: (state) => {
      state.isLoading = true;
    },
    responseFromFetchAccountAddressList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.addressList = action.payload ?? [];
    },
    failedToFetchAccountAddressList: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    requestToDeleteAccountAddress: (state) => {
      state.isDeleteLoading = true;
    },
    responseFromDeleteAccountAddress: (state, action) => {
      state.isDeleteLoading = false;
      const removedId = action.payload?.addressId;
      if (removedId && Array.isArray(state.addressList)) {
        state.addressList = state.addressList.filter((row) => row.id !== removedId);
      }
    },
    failedToDeleteAccountAddress: (state) => {
      state.isDeleteLoading = false;
    },
    setAccountEditAddressDetails: (state, action) => {
      state.editAddressDetails = action.payload ?? null;
    },
    resetAccountEditAddressDetails: (state) => {
      state.editAddressDetails = null;
      state.isEditAddressSuccess = false;
    },
    requestToFetchAccountEditAddress: (state) => {
      state.isLoading = true;
    },
    responseFromFetchAccountEditAddress: (state, action) => {
      state.isLoading = false;
      state.editAddressDetails = action.payload ?? null;
    },
    failedToFetchAccountEditAddress: (state) => {
      state.isLoading = false;
    },
    requestToSaveAccountAddress: (state) => {
      state.isSaveLoading = true;
      state.isEditAddressSuccess = false;
    },
    responseFromSaveAccountAddress: (state) => {
      state.isSaveLoading = false;
      state.isEditAddressSuccess = true;
      state.addressList = null;
    },
    failedToSaveAccountAddress: (state) => {
      state.isSaveLoading = false;
    },
  },
});

export const {
  requestToFetchAccountAddressList,
  responseFromFetchAccountAddressList,
  failedToFetchAccountAddressList,
  requestToDeleteAccountAddress,
  responseFromDeleteAccountAddress,
  failedToDeleteAccountAddress,
  setAccountEditAddressDetails,
  resetAccountEditAddressDetails,
  requestToFetchAccountEditAddress,
  responseFromFetchAccountEditAddress,
  failedToFetchAccountEditAddress,
  requestToSaveAccountAddress,
  responseFromSaveAccountAddress,
  failedToSaveAccountAddress,
} = accountAddressBookSlice.actions;

export default accountAddressBookSlice.reducer;
